import axios from "axios";
import UrlHelper from "../utilities/UrlHelper";

class EmailAuthenticationService {
    // 'Use-Virtual-Session' - send verification email for logged VirtualUser without email
    sendVerifyEmail (request) {
        return axios
            .post(UrlHelper.getIdentifiApiUrl() + 'auth/email/SendVerificationEmail', request, {
                headers: {
                    'Use-Virtual-Session': 'true'
                }
            });
    }

    sendEmailOnUpgradeToVirtualUser (email) {
        const request = {
            Email: email
        };

        return axios
            .post(UrlHelper.getIdentifiApiUrl() + 'auth/email/SendOnUpgradeToVirtualUser', request);
    }

    startLogin(email) {
        const request = {
            Email: email
        };

        return axios
            .post(UrlHelper.getIdentifiUrl() + "AuthActions/StartEmailLogin", request);
    }

    startUpgradeToVirtualUser(email) {
        const request = {
            Email: email
        };

        return axios
            .post(UrlHelper.getIdentifiUrl() + "AuthActions/StartUpgradeToVirtualUser", request);
    }

    setPassword(ticket, pin, password) {
        const request = {
            Password: password,
            Ticket: ticket,
            Pin: pin
        };

        return axios
            .post(UrlHelper.getIdentifiUrl() + "AuthActions/setPassword", request);
    }

    resetPassword(ticket, password) {
        const request = {
            Password: password,
            Ticket: ticket
        };

        return axios
            .post(UrlHelper.getIdentifiUrl() + "AuthActions/resetEmailPassword", request);
    }


    upgradeToVirtualUser(ticket, password) {
        const request = {
            Password: password,
            Ticket: ticket
        };

        return axios
            .post(UrlHelper.getIdentifiUrl() + "AuthActions/upgradeToVirtualUser", request);
    }

    linkToVirtualUser(email, password, callback) {
        const request = {
            Password: password,
            Email: email
        };

        return axios.post(UrlHelper.getIdentifiUrl() + "AuthActions/linkToVirtualUser", request);
    }

    validateUserTicket(ticket, type) {
        const request = {
            Ticket: ticket,
            Type: type
        };

        return axios.post(UrlHelper.getIdentifiApiUrl() + "auth/ticket/validate", request);
    }

    validateVirtualUserTicket(ticket, type) {
        const request = {
            Ticket: ticket,
            Type: type
        };

        return axios.post(UrlHelper.getIdentifiApiUrl() + "auth/email/validateTicket", request);
    }

    completeEmailLogin (request) {
        return axios.post(UrlHelper.getIdentifiUrl() + "AuthActions/CompletePasswordLogin", request);
    }

    sendResetPasswordLink(request, callback) {
        return axios.post(UrlHelper.getIdentifiApiUrl() + "auth/email/StartResetPassword", request);
    }

    getTicketExpirationPeriod(isVirtualUser, ticketType, callback){
        return axios.get(UrlHelper.getIdentifiApiUrl() + "auth/email/ticketTimeout?isVirtualUser=" + isVirtualUser + "&ticketType=" + ticketType);
    }

    // 'Use-Virtual-Session' - set email for logged VirtualUser (opened from verification email)
    setEmail(ticket){
        const request = {
            Ticket: ticket
        };

        return axios.post(UrlHelper.getIdentifiApiUrl() + "auth/email/setEmail", request, {
            headers: {
                'Use-Virtual-Session': 'true'
            }
        });
    }

    validatePin(pin, ticket) {
        const request = {
            Pin: pin,
            Ticket: ticket
        };

        return axios.post(UrlHelper.getIdentifiApiUrl() + "auth/pin/validate", request);
    }
}
export default new EmailAuthenticationService();
